// extracted by mini-css-extract-plugin
module.exports = {"cart-content":"cart_cart-content__p2Bjc","cart-empty":"cart_cart-empty__oxFij","cart__indicator":"cart_cart__indicator__uqqNb"};